import React, { Component } from "react";

//other components
import Select from "react-select";

//generic functions
import {
    isEmpty
} from "../../../functions/generic_functions";

/*
    props: 
        className => to format
        name => name of input

        options => json containing the select list
        isClearable => true/false allows clearing of single dropdown
        placeholder => placeholder text

        value => value of reactselect(an object) that is directly set and changes upon parent

        required => true/false sets the required field for input text 
        disabled => true/false disabling box

        multi => true/false, allows multiple selections
*/

//TODO: HANDLE MULTI dropdown
class CustomDropdown extends Component {

    state = {
        focused: false,
    }

    constructor(props) {
        super(props);
  
        //rendering ui 
        this.renderEmptyBorderClass = this.renderEmptyBorderClass.bind(this);

        //action handlers
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleOnFocus = this.handleOnFocus.bind(this);   
        this.handleOnBlur = this.handleOnBlur.bind(this);

        //helper functions
        this.getReactSelectValueObjFromValueProp = this.getReactSelectValueObjFromValueProp.bind(this);
    }

    //packages the passed in default value into a react-select object and returns it
    getReactSelectValueObjFromValueProp() {
        var value = (!isEmpty(this.props.value) ? this.props.value : null);
        var valueObj = null;

        //if the default value is not null , package it
        if(value !== null) {
            //package it into an object
            valueObj = {
                name: this.props.name,
                value: value,
                label: value
            };
        }

        //return the state to be set
        return valueObj;
    }
    
    renderEmptyBorderClass() {
        //if not disabled, required, not focused and the current value is empty, return the empty border class
        if (!this.props.disabled
            && this.props.required 
            && isEmpty(this.getReactSelectValueObjFromValueProp())
            && !this.state.focused
        ) {
            return "react_select_empty_border";
        }
        else {
            return "";
        }
    }

    handleOnChange(selectedOptionObj) {

        //selectedOptionOj is in the form of {name: "something", value: "another", label: "another label"}
        var currVal = null;

        if (!isEmpty(selectedOptionObj)) {
            currVal = selectedOptionObj.value;
        }

        //set the value at the parent if the set function exists
        if (this.props.onChangeSetParentState) {
            this.props.onChangeSetParentState(currVal, this.props.name);
        }
    }

    handleOnBlur() {
        //on blur, set focused to false
        this.setState({
            focused: false,
        });
    }

    handleOnFocus() {
        //if on focus, sets focused flag to true
        this.setState({
            focused: true,
        });
    }

    render() {
        return (
            <React.Fragment>
                <Select
                    name={this.props.name} 
                    options={this.props.options}
                    value={this.getReactSelectValueObjFromValueProp()}
                    className={this.props.disabled ? "select_disabled_input_box_format ": "input_box_format " + (!isEmpty(this.props.className) ? this.props.className : "") + " " + this.renderEmptyBorderClass()}
                    placeholder={this.props.placeholder}
                    isClearable={(!isEmpty(this.props.isClearable) ? this.props.isClearable : true)}
                    isDisabled={(!isEmpty(this.props.disabled) ? this.props.disabled : false)}
                    onChange={(e) => this.handleOnChange(e)}
                    onFocus={(e) => this.handleOnFocus(e)}
                    onBlur={(e) => this.handleOnBlur(e)}
                    isMulti={!isEmpty(this.props.isMulti) ? this.props.isMulti : false}
                />
            </React.Fragment>
        );
    }
}

export default CustomDropdown;


